import {
  AnalyticsBrowser,
  EventProperties,
  Options,
  UserTraits,
} from '@customerio/cdp-analytics-browser';

import { ENV } from '@utils/env';

interface Services {
  customerio: AnalyticsBrowser | undefined;
}

const services: Services = {
  customerio: undefined,
};

/**
 * Initialize and load analytics services.
 */
export function initAnalytics() {
  if (ENV.customerio.writeKey) {
    services.customerio = AnalyticsBrowser.load({
      cdnURL: 'https://cdp-eu.customer.io',
      writeKey: ENV.customerio.writeKey,
    });
  }
}

export const analytics = {
  /**
   * Identifies the current user.
   */
  async identify(email: string, traits?: UserTraits) {
    const name = [traits?.firstName, traits?.lastName]
      .filter(Boolean)
      .join(' ');

    try {
      // If the Common Room script has been injected by GTM then call the
      // identify method. GTM stubs `window.signals` synchronously, but the
      // script's own load() can still be resolving in the background, so
      // this can throw ("No visitor ID available. Load may have failed.")
      // before it's ready.
      window.signals?.identify({
        email,
        name: name || undefined,
      });
    } catch {
      // ignore, Common Room script not fully loaded yet
    }

    try {
      await services.customerio?.identify(email, traits);
    } catch {
      // ignore, ad-blocker enabled
    }

    if (ENV.dev) {
      // eslint-disable-next-line no-console
      console.log('[IDENTIFY]', email, traits);
    }
  },

  /**
   * Tracks a custom event.
   */
  async track(
    eventName: string,
    properties?: EventProperties,
    options?: Options
  ) {
    try {
      await services.customerio?.track(eventName, properties, options);
    } catch {
      // ignore, ad-blocker enabled
    }

    if (ENV.dev) {
      // eslint-disable-next-line no-console
      console.log('[TRACK]', eventName, properties, options);
    }
  },

  /**
   * Tracks a page view.
   */
  async page() {
    try {
      await services.customerio?.page();
    } catch {
      // ignore, ad-blocker enabled
    }

    if (ENV.dev) {
      // eslint-disable-next-line no-console
      console.log('[PAGE]');
    }
  },
};
